import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const applicationStatusReason = {
  state: {
    applicationStatusReasons: [],
    selectedApplicationStatusReason: {},
    selectedApplicationStatusReasonOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    applicationStatusReasons(state) {
      return state.applicationStatusReasons
    },
    selectedApplicationStatusReason(state) {
      return state.selectedApplicationStatusReason
    },
    selectedApplicationStatusReasonOriginal(state) {
      return state.selectedApplicationStatusReasonOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    applicationStatusReasons(state, payload) {
      state.applicationStatusReasons = payload
    },
    selectedApplicationStatusReason(state, payload) {
      state.selectedApplicationStatusReason = JSON.parse(JSON.stringify(payload))
    },
    selectedApplicationStatusReasonOriginal(state, payload) {
      state.selectedApplicationStatusReasonOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedApplicationStatusReason(context, payload) {
      context.commit('selectedApplicationStatusReason', payload)
    },
    async loadApplicationStatusReasons(context, payload) {
      const url = 'ApplicationStatusReason'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('applicationStatusReasons', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedApplicationStatusReason(context, payload) {
      if (
        context.state.selectedApplicationStatusReason &&
        context.state.selectedApplicationStatusReason.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedApplicationStatusReason',
          context.state.selectedApplicationStatusReason.Id
        )
      }
    },
    async loadSelectedApplicationStatusReason(context, payload) {
      if (
        context.state.selectedApplicationStatusReason &&
        context.state.selectedApplicationStatusReason.Id != payload
      ) {
        context.commit('selectedApplicationStatusReason', {})
      }
      const url = 'ApplicationStatusReason/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedApplicationStatusReason', res.data)
        context.commit('selectedApplicationStatusReasonOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadApplicationStatusReasons(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadApplicationStatusReasons')
    },
    async createApplicationStatusReason(context, payload) {
      const url = `ApplicationStatusReason`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'application status reason created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationStatusReasons')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchApplicationStatusReason(context, payload) {
      var item = context.state.selectedApplicationStatusReason
      if (
        payload.Id &&
        payload.Id == context.state.selectedApplicationStatusReasonOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedApplicationStatusReasonOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `ApplicationStatusReason/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'application status reason updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadApplicationStatusReasons')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateApplicationStatusReason(context, payload) {
      const url = `ApplicationStatusReason/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'application status reason updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationStatusReasons')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveApplicationStatusReason(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateApplicationStatusReason', payload)
      } else {
        return context.dispatch('createApplicationStatusReason', payload)
      }
    },
    async deleteApplicationStatusReason(context, payload) {
      const url = `ApplicationStatusReason/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'application status reason deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationStatusReasons')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default applicationStatusReason
